export const SavingsKpisActionTypes = {
    API_RESPONSE_SUCCESS: '@@savings-kpis/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@savings-kpis/API_RESPONSE_ERROR',
    GET_SHIPMENTS_BASELINE_COST_REQUEST: '@@savings-kpis/GET_SHIPMENTS_BASELINE_COST_REQUEST',
    GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST: '@@savings-kpis/GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST',
    GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST: '@@savings-kpis/GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST',
    GET_SHIPMENTS_COST_BY_CARRIER_REQUEST: '@@savings-kpis/GET_SHIPMENTS_COST_BY_CARRIER_REQUEST',
    GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST: '@@savings-kpis/GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST',
    GET_SHIPMENTS_COST_OVERVIEW_REQUEST: '@@savings-kpis/GET_SHIPMENTS_COST_OVERVIEW_REQUEST',
};
